export const CONTEXT_MENU_CHILDREN_WRAPPER_TESTID =
	'software-context-menu.ui.context-menu.children-wrapper';
